import React from 'react';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { listViewStyles } from '../../../styles';
import { ITopic } from '../../../../dataObjects/models/topics/Topic';
import TopicsListViewItem from './TopicsListViewItem';
import { IUserAccessPermissionsForObject, UserAccessPermissionsForObject } from '../../../../dataObjects/models/collaboration/ObjectUserPermissions';
import { IUser } from '../../../../dataObjects/models/users/User';
import { IChannel } from '../../../../dataObjects/models/channels/Channel';
import { ITopicViewModel } from '../../../../dataObjects/viewModels/topicViewModel';


// The next line is preserved for update to React 18, once peer dependencies will allow the update
// export interface ITopicsListViewProps extends PropsWithChildren<unknown> {
export interface ITopicsListViewProps {
  topicViewModels: Array<ITopicViewModel>;
  currentUser: IUser;
  channel: IChannel;
  onDelete: (topic: ITopic) => void;
  onDeleteProfileImage: (topicViewModel: ITopicViewModel) => void;
}

export const TopicsListView: React.FC<ITopicsListViewProps> = (props: ITopicsListViewProps) => {
  TopicsListView.displayName = 'Topics List View';

  // eslint-disable-next-line no-console
  // console.info(`Render TopicsListView`);

  const classes: Record<string, string> = listViewStyles();

  const { topicViewModels, currentUser, channel, onDelete, onDeleteProfileImage } = props;

  const userPermissions : IUserAccessPermissionsForObject = new UserAccessPermissionsForObject(currentUser.id, channel);

  return (
    <>
      {/* overall grid for list. There will be a header row and two data rows: 
          - Header Row
          - Data Row 1: Name & Action Buttons
          - Data Row 2: Description
      */}
      <Grid container direction="column" >
        {/* Header Row */}
        <Grid key='tableHeader' container className={classes.tableHeader} size={12} direction="row">
          <Grid key='nameAndDescriptionLabel' size={{ xs: 12, md: 9 }} >
            <Typography variant='h6'>
              Name / Description
            </Typography>
          </Grid>
          <Grid container size={{ md: 3 }} direction="row" justifyContent="center" alignContent="flex-start">
            <Grid key='topicItemsLabel' container className={classes.actionButtonLabelContainer} size={{ md: 4 }} justifyContent='center' >
              {/* Only display the next label if the screen size is Medium or larger */}
              <Box sx={{ display: { xs: 'none', md: 'block' } }} >
                <Typography variant='h6'>
                  Topic Items
                </Typography>
              </Box>
            </Grid>
            <Grid key='editLabel' container className={classes.actionButtonLabelContainer} size={{ md: 4 }} justifyContent='center' >
              {/* Only display the next label if the screen size is Medium or larger */}
              <Box sx={{ display: { xs: 'none', md: 'block' } }} >
                <Typography variant='h6'>
                  Edit
                </Typography>
              </Box>
            </Grid>
            <Grid key='deleteLabel' container className={classes.actionButtonLabelContainer} size={{ md: 4 }} justifyContent='center' >
              {/* Only display the next label if the screen size is Medium or larger */}
              <Box sx={{ display: { xs: 'none', md: 'block' } }} >
                <Typography variant='h6'>
                  Delete
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        {
          topicViewModels.map((topicViewModel, idx) => (
            <TopicsListViewItem
              key={topicViewModel.topic.id}
              topicViewModel={topicViewModel}
              userPermissions={userPermissions}
              onDelete={onDelete}
              onDeleteProfileImage={onDeleteProfileImage}
            />
          ))
        }
      </Grid>
    </>
  );
};

export default TopicsListView;
